// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".price[data-v-609d6160]{font-weight:500}.primary[data-v-609d6160]{color:#333}.secondary[data-v-609d6160]{color:#fd595e}.white[data-v-609d6160]{color:#fff}.small[data-v-609d6160]{font-size:1.6rem}.medium[data-v-609d6160]{font-size:1.7rem}.large[data-v-609d6160]{font-size:2.4rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
